import React, { FC } from 'react';
import { create } from 'zustand';

export interface DoorsStore {
  items: any[];
  index: number;
  setItems: (newItems: any) => void;
  setQuizAnswer: (newAnswer: any) => void;
  doorIds: string[];
  setDoorIds: (ids: string[]) => void;
  completedDoorIds: string[];
  markDoorCompleted: (id: string) => void;
}

const _useDoorsStore = create<DoorsStore>((set, get) => ({
  items: [],
  index: -1,
  doorIds: [],
  completedDoorIds: [],
  setItems: newItems => {
    set({ items: newItems });
    if (get().index === -1) {
      set({ index: newItems.findIndex((item: string) => item === 'XXX') });
    }
  },
  setQuizAnswer: newAnswer => {
    const ARRAY = get().items;
    ARRAY[get().index] = newAnswer;

    set({ items: ARRAY });
  },
  setDoorIds: ids => set({ doorIds: ids }),
  markDoorCompleted: id =>
    set(s => ({
      completedDoorIds: s.completedDoorIds.includes(id)
        ? s.completedDoorIds
        : [...s.completedDoorIds, id]
    }))
}));

export const DoorsProvider: FC = ({ children }) => <>{children}</>;
export const useDoorsStore = _useDoorsStore;
